module.exports = __webpack_public_path__ + "img/Radio_Button_Filled_Red.423d7e98.svg";